<template>
  <div id="app">
    <AppHeader />
    <main class="app-main">
      <router-view />
    </main>
    <AppFooter />
    <transition name="toast">
      <div v-if="toastMessage" class="toast" role="status">{{ toastMessage }}</div>
    </transition>
    <transition name="dialog-fade">
      <div v-if="dialogMessage" class="dialog-backdrop" @click.self="closeDialog">
        <section
          class="message-dialog"
          role="dialog"
          aria-modal="true"
          :aria-label="$store.getters.t('noResults')"
        >
          <button
            ref="dialogClose"
            type="button"
            class="message-dialog__close"
            :title="$store.getters.t('close')"
            :aria-label="$store.getters.t('close')"
            @click="closeDialog"
          ><span aria-hidden="true"></span></button>
          <p>{{ dialogMessage }}</p>
          <button type="button" class="message-dialog__action" @click="closeDialog">
            {{ $store.getters.t('close') }}
          </button>
        </section>
      </div>
    </transition>
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'
import { recordVisit } from './api/portal'

export default {
  name: 'App',
  components: { AppHeader, AppFooter },
  data () {
    return { toastMessage: '', toastTimer: null, dialogMessage: '' }
  },
  created () {
    this.$store.dispatch('loadSiteData')
    this.recordPageVisit()
    window.addEventListener('portal-message', this.showMessage)
    window.addEventListener('portal-dialog', this.showDialog)
    window.addEventListener('keydown', this.handleKeydown)
    window.addEventListener('resize', this.syncHeaderWidth)
    this.$nextTick(this.syncHeaderWidth)
  },
  beforeDestroy () {
    window.removeEventListener('portal-message', this.showMessage)
    window.removeEventListener('portal-dialog', this.showDialog)
    window.removeEventListener('keydown', this.handleKeydown)
    window.removeEventListener('resize', this.syncHeaderWidth)
    clearTimeout(this.toastTimer)
  },
  watch: {
    '$route.fullPath' () { this.recordPageVisit() }
  },
  methods: {
    recordPageVisit () {
      recordVisit({ path: this.$route.fullPath }).catch(() => {})
    },
    syncHeaderWidth () {
      document.documentElement.style.setProperty('--page-content-width', `${document.body.clientWidth}px`)
    },
    showMessage (event) {
      this.toastMessage = event.detail || ''
      clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toastMessage = '' }, 3200)
    },
    showDialog (event) {
      this.dialogMessage = event.detail || ''
      this.$nextTick(() => {
        if (this.$refs.dialogClose) this.$refs.dialogClose.focus()
      })
    },
    closeDialog () {
      this.dialogMessage = ''
    },
    handleKeydown (event) {
      if (event.key === 'Escape' && this.dialogMessage) this.closeDialog()
    }
  }
}
</script>
